import Layout from "layouts/DashboardLayout.jsx";
import resetPassword from "views/pages/superAdmin/resetPassword";
import {
  Login,
  Register,
  Error400,
  ForgotPassword,
  Error500,
  MerchantRegister,
  MerchantLogin,
  MerchantForgetPassword,
  MerchantResetPassword,
  TermsAndConditions,
  PrivacyPolicy,
  DeleteAccount
} from "./../views/pages/index";

const indexRoutes = [
  { path: "/admin/login", component: Login },
  { path: "/admin/register", component: Register },
  { path: "/admin/forgotpassword", component: ForgotPassword },
  { path: "/admin/resetpassword/:id", component: resetPassword },
  { path: "/error400", component: Error400 },
  { path: "/error500", component: Error500 },
  { path: "/register", component: MerchantRegister },
  { path: "/login", component: MerchantLogin },
  { path: "/forgetpassword", component: MerchantForgetPassword },
  { path: "/resetpassword/:id", component: MerchantResetPassword },
  { path: "/terms-and-conditions", component: TermsAndConditions },
  { path: "/privacy-policy", component: PrivacyPolicy },
  { path: "/delete-account", component: DeleteAccount },
  { path: "/", component: Layout }
];

export default indexRoutes;
